import { Button, message, TableProps, Tooltip } from "antd";
import { IReferrerList } from "./types";
import { CopyOutlined } from "@ant-design/icons";
import { copyToClipboard } from "../../../constants/copyToClipboard";
import { environment } from "../../../environments/environment";

export const getColumns = (): TableProps<IReferrerList>["columns"] => [
	{
		title: "Name",
		dataIndex: "name",
		key: "name",
		sorter: (a, b) => a.name.localeCompare(b.name)
	},
	{
		title: "Email",
		dataIndex: "email",
		key: "email",
		sorter: (a, b) => a.email.localeCompare(b.email)
	},
	{
		title: "Referral Code",
		dataIndex: "referralCode",
		key: "referralCode",
		sorter: (a, b) => a.referralCode.localeCompare(b.referralCode)
	},
	{
		title: "Created Date",
		dataIndex: "createdDate",
		key: "createdDate",
		sorter: (a, b) => new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime(),
		render: (date: string) =>
			new Date(date).toLocaleDateString("en-GB", {
				day: "2-digit",
				month: "short",
				year: "numeric"
			})
	},
	{
		title: "Referral Link",
		key: "referralLink",
		render: (_, record) => {
			const link = `${environment.creatorRegisterUrl}?ref=${record.referralCode}`;

			const handleCopy = async () => {
				const success = await copyToClipboard(link);
				if (success) message.success("Referral link copied!");
				else message.error("Failed to copy link");
			};

			return (
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						background: "#fafafa",
						padding: "6px 10px",
						borderRadius: 6,
						border: "1px solid #f0f0f0",
						maxWidth: 260
					}}
				>
					<Tooltip title={link}>
						<span
							style={{
								fontSize: 12,
								color: "#555",
								overflow: "hidden",
								textOverflow: "ellipsis",
								whiteSpace: "nowrap",
								maxWidth: 160
							}}
						>
							{link}
						</span>
					</Tooltip>

					<Tooltip title="Copy link">
						<Button type="text" size="small" icon={<CopyOutlined />} onClick={handleCopy} />
					</Tooltip>
				</div>
			);
		}
	}
];
